import { FeatureGridItem } from '@lucid/components-react';
import { Drupal_FieldParagraphFeaturedGridSectionFieldFeaturedGridItems, Drupal_ParagraphFeaturedGridItem, Drupal_ParagraphSeoImage } from 'generated/drupal-graphql';

export const mapFeaturedGridItems = (item: Drupal_FieldParagraphFeaturedGridSectionFieldFeaturedGridItems): FeatureGridItem => {
  const entity = item.entity as Drupal_ParagraphFeaturedGridItem;
  const image = entity?.fieldSectionImage?.entity as Drupal_ParagraphSeoImage;
  return {
    description: entity?.fieldItemSectionDescription?.processed,
    id: entity?.id,
    title: entity?.fieldTitle,
    image: image && {
      imageAlt: image?.fieldAltText,
      imageSrc: image?.fieldImageLink
    },
    cta: entity?.fieldCta && {
      linkText: entity?.fieldCta?.title,
      linkUrl: entity?.fieldCta?.url?.path
    },
  } as FeatureGridItem;
};
